import React, { Component } from "react";
import PropsType from "prop-types";
import "./_style/ripple.css";
import XDiv from "./XDiv";

/**
 * @augments {Component<Props, State>}
 */
class XRipple extends Component {

  static propTypes = {
    duration: PropsType.number,
    color: PropsType.string,
    opacity: PropsType.number,
    allowMultiple: PropsType.bool,
    style: PropsType.object,
    enabled: PropsType.bool,
    forwardRef: PropsType.object
  }

  static defaultProps = {
    duration: 850,
    color: "white",
    opacity: 0.75,
    allowMultiple: true,
    style: {},
    enabled: true,
    forwardRef: null
  }

  constructor(){
    super();
    this.state = {
      spanStyles: {},
      count: 0
    };
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentWillUnmount() {
    if(this.bounce) clearTimeout(this.bounce);
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  showRipple = (e) => {
    let {count} = this.state;
    let {color, opacity, duration, allowMultiple, enabled} = this.props;
    if(!enabled || (!allowMultiple && count > 0)) return;
    let rippleContainer = e.currentTarget;
    let size = rippleContainer.offsetWidth;
    let pos = rippleContainer.getBoundingClientRect();
    let x = e.pageX - pos.x - (size / 2);
    let y = e.pageY - pos.y - (size / 2);
    let spanStyles = { 
      top: y, 
      left: x,
      height: size,
      width: size,
      transform: "scale(0)",
      borderRadius: "100%",
      position: "absolute",
      opacity: opacity,
      backgroundColor: color,
      animation: "izoxripple " + duration + "ms"
    };
    let newCount = this.state.count + 1;
    this.setState({
      spanStyles: {...this.state.spanStyles, [count] : spanStyles},
      count: newCount
    });
  }

  renderRippleSpan = () => {
    let {spanStyles = {}} = this.state;
    let spanArray = Object.keys(spanStyles);
    if (spanArray && spanArray.length > 0) {
      return (
        spanArray.map((key, index) => {
          return (
            <span key={"spanCount_" + index} className="" 
              style={{ ...spanStyles[key]}}>
            </span>
          );
        })
      );
    } else {
      return null;
    }
  }

  cleanUp = () => {
    this.setState({
      spanStyles: {},
      count: 0
    });
  }
  
  callCleanUp = (cleanup, delay) => {
    return () => {
      clearTimeout(this.bounce);
      this.bounce = setTimeout(() => {
        cleanup();
      }, delay);
    };
  }

  render(){
    let  { children = null, onMouseDown = null, onMouseUp = null, 
      duration, style, onMouseEnter, onMouseLeave, forwardRef } = this.props;
    return (
      <XDiv className={"izoxripple"} 
        onMouseDown={onMouseDown} 
        onMouseUp={onMouseUp}
        noPropagation
        style={{
          lineHeight: 1,
          boxSizing: "inherit !important",
          ...style
        }} forwardRef={forwardRef}>
        {children}
        <XDiv className="izoxrippleContainer" 
          noPropagation
          onMouseDown={this.showRipple} 
          onMouseUp={this.callCleanUp(this.cleanUp, duration)}
          onMouseLeave={onMouseLeave}
          onMouseEnter={onMouseEnter}>
          {this.renderRippleSpan()}
        </XDiv>
      </XDiv>
    );
  }

}

export default XRipple;
